<template>
  <div class="form-container">
    <div style="margin-left: 80px">
      <el-tabs class="tfam-custom-tabs" v-model="currentLang">
        <el-tab-pane
          v-for="(lang) in langList"
          :key="lang['language_key']"
          :label="lang['title']"
          :name="lang['language_key']"></el-tab-pane>
      </el-tabs>
    </div>
    <el-form v-if="artist" ref="form" :model="artist" label-width="80px" label-position="left">
      <el-form-item label="姓名">
        <el-input v-model="artist[currentLang]['name']"></el-input>
      </el-form-item>
      <el-form-item label="性別">
        <el-select v-model="artist.gender" placeholder="請選擇性別">
          <el-option label="男" value="male"></el-option>
          <el-option label="女" value="female"></el-option>
          <el-option label="其他" value="else"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="國籍">
        <el-select
          v-model="artist['nation_id']"
          filterable
          :popper-append-to-body="false"
          placeholder="選擇國籍">
          <el-option
            v-for="item in nationList"
            :key="item['nation_id']"
            :label="item['name'] + ' ' + item['name_eng']"
            :value="item['nation_id']">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生卒年">
        <el-row>
          <el-row class="range-content">
            <el-input v-model="artist.born"></el-input>
            <span class="divider">－</span>
            <el-input v-model="artist.died"></el-input>
          </el-row>
        </el-row>
      </el-form-item>
      <el-form-item label="簡介">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5 }"
          v-model="artist[currentLang]['introduction']"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="tfam-button" v-loading.fullscreen.lock="fullLoading" plain @click="handleSubmitUpdate">更新並儲存</el-button>
        <el-button class="tfam-button" plain @click="goBack">返回至上一層</el-button>
        <el-button class="tfam-button" plain @click="handleDeleteRow">捨棄這筆資料</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { fetchArtist, createArtist, updateArtist, createArtistLang, updateArtistLang, deleteArtist, deleteArtistLang } from "../../api/artist";
  import { fetchNationList } from "../../api/nation";
  import lodash from 'lodash'
  export default {
    name: "ArtistEdit",
    data() {
      return {
        langList: this.$store.getters.langList,
        originalArtist: undefined,
        artist: undefined,
        artistId: '',
        currentLang: 'ZH_TW',
        nationList: [],
        fullLoading: false
      }
    },
    methods: {
      getNationList() {
        fetchNationList().then(response => {
          this.nationList = response.data;
        }).catch(err => {
        })
      },
      getArtistData() {
        const filter = {
          include: ['artistLangs']
        };
        fetchArtist(this.artistId, filter).then(response => {
          const artistData = response.data;
          this.langList.forEach(lang => {
            const key = lang['language_key'];
            const filter = artistData['artistLangs'].filter(x => x['language_key'] === lang['language_key']);
            if (filter.length > 0) {
              artistData[key] = filter[0]
            } else {
              artistData[key] = {
                artist_lang_id: 'new',
                language_key: key,
                name: '',
                nation: '',
                introduction: '',
                artist_id: this.artistId
              };
            }
          });
          console.log(artistData);
          this.artist = lodash.cloneDeep(artistData);
          this.originalArtist = lodash.cloneDeep(artistData);
        }).catch(e => {
        })
      },
      handleSubmitUpdate() {
        this.fullLoading = true;
        this.submitUpdate().then(response => {
          if (this.artistId === 'new') {
            this.artistId = response;
            this.$router.push({
              path: '/artists/' + this.artistId
            });
          }
          this.getArtistData();
          this.fullLoading = false;
        }).catch(err => {
          this.fullLoading = false;
        })
      },
      submitUpdate: async function() {
        try {
          const artistData = lodash.cloneDeep(this.artist);
          let artistId = artistData['artist_id'];
          if (artistId === 'new') {
            const newArtist = await createArtist(artistData);
            artistId = newArtist.data['artist_id'];
          } else {
            await updateArtist(artistId, artistData);
          }
          for (const i in this.langList) {
            const langKey = this.langList[i]['language_key'];
            const artistLangData = artistData[langKey];
            artistLangData['artist_id'] = artistId;
            const artistLangId = artistLangData['artist_lang_id'];
            if (artistLangId === 'new') {
              await createArtistLang(artistLangData)
            } else {
              await updateArtistLang(artistLangId, artistLangData)
            }
          }
          return Promise.resolve(artistId);
        } catch (e) {
          return Promise.reject(e);
        }
      },
      goBack() {
        this.$router.push({
          path: '/artists'
        })
      },
      handleDeleteRow() {
        if (confirm('確定要捨棄這筆資料嗎？\n(捨棄的資料將無法復原。)')) {
          if (this.artistId === 'new') {
            this.goBack();
          } else {
            this.fullLoading = true;
            this.submitDeleteRowData().then(response => {
              this.fullLoading = false;
              this.goBack();
            }).catch(err => {
              this.fullLoading = false;
            })
          }
        }
      },
      submitDeleteRowData: async function() {
        try {
          const promiseArray = [];
          promiseArray.push(deleteArtist(this.artistId));
          this.langList.forEach(lang => {
            const key = lang['language_key'];
            if (this.artist[key]['artist_lang_id'] !== 'new') {
              promiseArray.push(deleteArtistLang(this.artist[key]['artist_lang_id']));
            }
          });
          await Promise.all(promiseArray);
          return Promise.resolve(true);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    },
    mounted() {
      this.getNationList();
      this.artistId = this.$route.params.id;
      if (this.artistId !== 'new') {
        this.getArtistData()
      } else {
        const artistData = {
          artist_id: 'new',
          gender: '',
          born: undefined,
          died: undefined,
        };
        this.langList.forEach(lang => {
          const key = lang['language_key'];
          artistData[key] = {
            artist_lang_id: 'new',
            language_key: key,
            name: '',
            nation: '',
            introduction: '',
            artist_id: ''
          }
        });
        this.artist = artistData;
        this.originalArtist = lodash.cloneDeep(artistData);
      }
    }
  }
</script>

<style scoped>

</style>
